import { AppBar, Box, IconButton, Stack, Toolbar, Typography, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect, useRef, useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { PageContainer, PageContentBackground, PageHeader, PageRoot } from '../../app/AppStyles';
import BackButton from './BackButton';
import SearchField from './SearchField';

import SearchIcon from '@mui/icons-material/Search';

export default function PageLayout({
    content,
    contentLeft,
    contentRight,
    contentBottom,
    contentTopLeft,
    contentTopRight,
    bottomBar,
    title,
    titleLower,
    subtitle,
    style,
    fullScreen,
    disableHeaderBackground,
    disableContentBackground,
    enableSearch,
    searchFilter,
    searchFilterSet
}) {
    const textRef = useRef(null);
    const scrollRef = useRef(null);
    const desktop = useMediaQuery('(min-width:900px)');

    const [openSearch, setOpenSearch] = useState(false);

    const bottomBgcolor = theme => `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main} 95%)`;

    const handleToggle = () => {
        // Scroll to top if search is open
        if (openSearch && scrollRef.current.viewScrollTop > 0) {
            scrollRef.current.scrollTop(0);
            setTimeout(() => textRef.current.focus(), 100);
            return;
        };

        // Cant close search if there is a value
        if ((openSearch && textRef.current.value === "") || !openSearch)
            setOpenSearch(!openSearch);
        else
            setTimeout(() => textRef.current.focus(), 100);
    };

    useEffect(() => {
        if (openSearch)
            setTimeout(() => textRef.current.focus(), 100);
    }, [openSearch]);

    return (
        <>
            <Grid container sx={{ ...PageRoot }}>
                <Grid size={{ xs: 0, md: fullScreen ? 0 : 2 }} sx={{ display: { xs: 'none', md: 'flex' } }}>
                    {contentLeft}
                </Grid>
                <Grid size={{ xs: 12, md: fullScreen ? 12 : 8 }} sx={{ ...PageContainer, ...style }}>
                    {(desktop && (title || contentTopLeft || contentTopRight)) &&
                        <Box sx={{ mb: 1, pb: 0.5, ...(disableHeaderBackground ? {} : PageContentBackground) }}>
                            <Grid container spacing={1}>
                                <Grid size={2} sx={{ display: 'flex', alignContent: 'center', justifyContent: 'flex-start', p: 1 }}>{contentTopLeft}</Grid>
                                <Grid size={8}>
                                    {title &&
                                        <Stack justifyContent="center" sx={{ height: 1 }}>
                                            <Typography sx={{ ...PageHeader, typography: { xs: 'h5', md: 'h4' } }}>{title} {titleLower && titleLower.toLowerCase()}</Typography>
                                            {subtitle && <Typography sx={{ ...PageHeader, typography: { xs: 'h6', md: 'h5' } }}>{subtitle}</Typography>}
                                        </Stack>
                                    }
                                </Grid>
                                <Grid size={2} sx={{ display: 'flex', alignContent: 'center', justifyContent: 'flex-end', p: 1 }}>{contentTopRight}</Grid>
                            </Grid>
                        </Box>
                    }
                    <Scrollbars ref={scrollRef} autoHideTimeout={1000} autoHideDuration={200}>
                        <Stack spacing={1} sx={{ display: 'flex', p: disableContentBackground ? 0 : 1, minHeight: 1, ...(disableContentBackground ? {} : PageContentBackground) }}>
                            {(enableSearch && openSearch) && <Box sx={{ mb: 1 }}><SearchField initialValue={searchFilter} onDebouncedChange={searchFilterSet} externalRef={textRef} /></Box>}
                            {content}
                        </Stack>
                    </Scrollbars>
                </Grid>
                <Grid size={{ xs: 0, md: fullScreen ? 0 : 2 }} sx={{ display: { xs: 'none', md: 'flex' } }}>
                    <Stack spacing={0.5} sx={{ display: 'flex', flex: '1 1 auto', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                        {contentRight}
                    </Stack>
                </Grid>
            </Grid>
            {bottomBar && !desktop &&
                <AppBar position="static" color="primary" sx={{ top: 'auto', bottom: 0, height: 48, backgroundImage: bottomBgcolor }}>
                    <Toolbar sx={{ display: 'flex', minHeight: 1 }}>
                        <Typography sx={{ typography: 'h6', color: 'white.main', flexGrow: 1 }}>{title} {titleLower ? titleLower.toLowerCase() : ""}</Typography>
                        {contentBottom}
                        {enableSearch &&
                            <IconButton onClick={handleToggle}>
                                <SearchIcon sx={{ color: 'white.main', fontSize: 32 }} />
                            </IconButton>}
                        <BackButton />
                    </Toolbar>
                </AppBar>
            }
        </>
    )
}